export default __webpack_public_path__ + "static/media/kiama3.299d09ef.jpg";